import { WaiverService } from './services/waiver/waiver.service';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DetailsService } from '../pages/secure/account/details/details.service';
import { LoginInfoService } from '../pages/secure/account/login-info/login-info.service';
import { HistoryService } from './../pages/secure/account/history/history.service';
import { AddDependentFormComponent } from './components/add-dependent-form/add-dependent-form.component';
import { DatePickerComponent } from './components/date-picker.component';
import { GlobalFooterComponent } from './components/global-footer/global-footer.component';
import { GlobalHeaderComponent } from './components/global-header/global-header.component';
import { ModalSlideComponent } from './components/modal-slide.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { PaymentInformationComponent } from './components/payment-information/payment-information.component';
import { ReviewComponent } from './components/review/review.component';
import { SaeForgotPasswordComponent } from './components/sae-forgot-password/sae-forgot-password.component';
import { SaeLoginComponent } from './components/sae-login/sae-login.component';
import { SaeLoginService } from './components/sae-login/sae-login.service';
import { SaeRegistrationComponent } from './components/sae-registartion/sae-registration.component';
import { SaeResetPasswordComponent } from './components/sae-reset-password/sae-reset-password.component';
import { SelectCoverageComponent } from './components/select-coverage/select-coverage.component';
import { SuggestedAddressModalComponent } from './components/suggested-address-modal/suggested-address-modal.component';
import { UserDetailsComponent } from './components/user-details/user-details.component';
import { SafeHtmlPipe } from './pipes/safeHtml';
import { AuthGuardService } from './services/auth-guard.service';
import { AuthService } from './services/auth.service';
import { ConfigDataService } from './services/config-data.service';
import { DownloadFileUtil } from './services/downloadFile-utility';
import { FilesService } from './services/files.service';
import { HttpClientService } from './services/http-client-service';
import { PublicGuardService } from './services/public-guard.service';
import { TokenService } from './services/token.service';
import { UtilityService } from './services/utility.service';
import { WcsApiService } from './services/wcs-api-service';
import { PhoneNumberPipe } from './pipes/phone-number.pipe';
import { AddDependentAccountService } from '../pages/secure/account/add-dependent-account/add-dependent-account.service';
import { NewEnrollmentService } from '../pages/secure/new-enrollment/new-enrollment.service';
import { ValidatorService } from './services/validator.service';

@NgModule({
  declarations: [
    PageHeaderComponent,
    GlobalHeaderComponent,
    UserDetailsComponent,
    SelectCoverageComponent,
    GlobalFooterComponent,
    DatePickerComponent,
    SaeLoginComponent,
    SaeRegistrationComponent,
    SaeForgotPasswordComponent,
    SaeResetPasswordComponent,
    ModalSlideComponent,
    SuggestedAddressModalComponent,
    AddDependentFormComponent,
    ReviewComponent,
    PaymentInformationComponent,
    SafeHtmlPipe,
    PhoneNumberPipe
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  providers: [
    AuthService,
    TokenService,
    AuthGuardService,
    HttpClientService,
    WcsApiService,
    SaeLoginService,
    PublicGuardService,
    UtilityService,
    FilesService,
    DownloadFileUtil,
    DetailsService,
    LoginInfoService,
    ConfigDataService,
    HistoryService,
    PhoneNumberPipe,
    AddDependentAccountService,
    NewEnrollmentService,
    WaiverService,
    ValidatorService
  ],
  exports: [
    PageHeaderComponent,
    GlobalHeaderComponent,
    UserDetailsComponent,
    SelectCoverageComponent,
    GlobalFooterComponent,
    DatePickerComponent,
    SaeLoginComponent,
    SaeRegistrationComponent,
    SaeForgotPasswordComponent,
    SaeResetPasswordComponent,
    ModalSlideComponent,
    SuggestedAddressModalComponent,
    AddDependentFormComponent,
    ReviewComponent,
    PaymentInformationComponent,
    SafeHtmlPipe,
    PhoneNumberPipe
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],
  bootstrap: [
    PageHeaderComponent,
    GlobalHeaderComponent,
    UserDetailsComponent,
    SelectCoverageComponent,
    GlobalFooterComponent,
    DatePickerComponent,
    SaeLoginComponent,
    SaeRegistrationComponent,
    SaeForgotPasswordComponent,
    SaeResetPasswordComponent,
    ModalSlideComponent,
    SuggestedAddressModalComponent,
    AddDependentFormComponent,
    ReviewComponent,
    PaymentInformationComponent
  ],
})
export class CustomCommonModule { }
